<template>
  <div class="topic" :style="getBgStyle">
    <div class="header">
      <div class="title">
        {{ topicDetail.name }}
      </div>
      <div class="subtitle">
        {{ topicDetail.share?.desc }}
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="item in goodsList" :key="item.guid">
        <div class="left">
          <van-image fit="cover" :src="item.goods_cover_image"> </van-image>
        </div>
        <div class="right">
          <div class="top">
            <p class="title">{{ item.goods_subtitle }}</p>
            <p class="subhead">{{ item.goods_name }}</p>
          </div>
          <div class="bottom">
            <div class="num fa fa-heart">
              {{ item.goods_vr_sale_count }}人测过
            </div>
            <div class="right-button" @click="handleConfirm(item)">
              立即测试
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rich-text" v-html="topicDetail.content"></div>
  </div>
</template>

<script setup>
import { computed, onMounted, nextTick } from "vue";
import { useCreateOrder } from "./useCreateOrder";

const props = defineProps({
  topicDetail: {
    type: Object,
    default: () => ({}),
  },
  goodsList: {
    type: Array,
    default: () => [],
  },
});

const getBgStyle = computed(() => {
  const { bg_color, bg_image } = props.topicDetail;
  return {
    backgroundColor: bg_color,
    backgroundImage: `url(${bg_image})`,
  };
});
const [confirm] = useCreateOrder();

async function handleConfirm({ guid, puid, goods_version }) {
  confirm({ guid, puid, goods_version });
}
</script>

<style lang="less" scoped>
.topic {
  min-height: 100vh;
  padding: 0 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;

  .header {
    padding: 46px 0 16px 0;
    color: #fff;
    text-align: center;

    .title {
      text-shadow: 0px 3.5px 7px v-bind("topicDetail.btn_color");
      font-size: 26px;
      padding-bottom: 8px;
    }

    .subtitle {
      font-size: 15px;
      text-shadow: 0px 3.5px 7px rgba(150, 150, 150, 1);
    }
  }

  .list {
    .item {
      border-radius: 8px;
      padding: @padding-sm;
      margin-top: 16px;
      box-shadow: 0px 0px 6px #d6d6d6;
      background-color: #fff;

      &:first-child {
        margin-top: 0;
      }

      .space-between();

      .left {
        width: 90px;
        height: 90px;

        .van-image {
          width: 100%;
          height: 100%;

          :deep(img) {
            border-radius: 4px;
          }
        }
      }

      .right {
        flex: 1;
        padding-left: @padding-sm;
        .column-space-between();

        .top {
          .title {
            font-weight: bold;
            font-size: 15px;
          }

          .subhead {
            padding-top: 5px;
            color: @gray-color;
            font-size: @font-size-sm;
          }
        }

        .bottom {
          width: 100%;

          .space-between();

          .num {
            font-size: @font-size-sm;
            color: @gray-color;
            padding-top: 10px;

            &::before {
              color: @theme-color;
            }
          }

          .right-button {
            width: 90px;
            height: 26px;
            line-height: 26px;
            border-radius: 26px;
            padding: 0 @padding-base;
            background-color: @theme-color;
            color: #fff;
            font-size: @font-size-sm;
            text-align: center;
          }
        }
      }
    }
  }

  .rich-text {
    padding: 15px 0;
    font-size: @font-size-base;
    color: #3f3f3f;
    line-height: 24px;

    :deep(img) {
      display: block;
      width: 100%;
    }
  }
}
</style>
